var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border-2 rounded text-center",class:_vm.classes,domProps:{"textContent":_vm._s(`${_vm.progress}%`)}})
}
var staticRenderFns = []

export { render, staticRenderFns }